export const INITIAL_DISCONT = 0;
